import axios from "axios";
import {Formik, Form} from "formik";
import React, {useContext, Fragment, useState} from "react";

import {ModalContext} from "app/app";
import {FieldInput} from "components/fieldInput";

import styles from "./styles.module.scss";
import {useParams} from "react-router-dom";

export default function BindRequestIssueModal() {
  const {modal, setModal} = useContext(ModalContext);
  const {id} = useParams();
  const [sending, setSending] = useState(false);

  const handleSubmit = async (values) => {
    setSending(true);
    try {
      if (!modal.data) {
        throw new Error("Modal data is undefined");
      }

      const formData = new FormData();
      formData.append("sender", "Cover Badger Processing Team");
      formData.append("receiver", modal.data.assignedAgentEmail);
      formData.append("description", values.description);
      formData.append("title", "Action is required");
      values.documents.forEach((file) => {
        formData.append("documents", file);
      });

      const response = await axios.put(`/api/bind-requests/${id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data.success) {
        setSending(false);
        setModal("");
        window.location.reload();
      }
    } catch (error) {
      console.error("Error sending message to client: ", error);
      setSending(false);
    }
  };

  return (
    <Fragment>
      {modal.name === "bind_request_issue_modal" && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.insideWrapper}>
              <div
                style={{
                  fontStyle: "normal",
                  fontWeight: 500,
                  fontSize: 24,
                  marginBottom: 12,
                  color: "black",
                }}
              >
                Explain more about the issue
              </div>
              <Formik
                initialValues={{description: "", documents: []}}
                onSubmit={handleSubmit}
              >
                {({setFieldValue, handleChange}) => (
                  <Form className={styles.form} encType="multipart/form-data">
                    <div
                      style={{
                        width: "100%",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "black",
                        marginTop: 20,
                        marginBottom: 12,
                      }}
                    >
                      <div style={{marginBottom: 12}}>
                        <label className="block text-sm-slate-800 text-base mb-1.5">
                          Describe the issue
                        </label>
                        <textarea
                          className="w-full p-2 border border-slate-300 rounded-lg"
                          rows="4"
                          placeholder="Enter text here..."
                          name="description"
                          onChange={handleChange}
                        />
                      </div>

                      <FieldInput
                        id="documents"
                        type="upload_multiple"
                        label="Upload files to help agency address the issue"
                        handleChange={(files_callback) => {
                          handleChange("documents");
                          setFieldValue(
                            "documents",
                            Array.from(files_callback.files),
                          );
                        }}
                        multiple
                      />
                    </div>

                    <div
                      className={styles.footer}
                      style={{justifyContent: "flex-end"}}
                    >
                      <div className={styles.buttons}>
                        <button
                          className={styles.cancel}
                          onClick={() => {
                            setModal("");
                          }}
                        >
                          Cancel
                        </button>

                        <button
                          className={styles.save}
                          type="submit"
                          disabled={sending}
                        >
                          {sending ? "Sending..." : "Submit"}
                        </button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}
